import React from 'react'
import HomeBanner from '../components/Home/HomeBanner';
import SharedSafariSection from '../components/Home/SharedSafariSection';

import AnimalSafari from '../components/Home/AnimalSafari';
import ParkSession from '../components/ParkSession/ParkSession';
import SafariPakageSection from 'components/Home/SafariPakageSection';


const Home = () => {

  return (
    
      <HomeContent />

  )
}


const HomeContent = () => {

  return (
    <>
    <div className="header_content ">
      <HomeBanner />
      <SharedSafariSection />
      <SafariPakageSection />
      <ParkSession />
      <AnimalSafari />
      {/* <ArticalSection /> */}
      </div>
    </>
  );
}

export default Home;
